import { AxInit, ModuleName } from "../../Lib/AxSystem/AxInit";
import { I18nHelper, Translations } from "../../Lib/Helper/I18nHelper";
import { AxFormValidation, AxInput } from "@axess/limestone";
import { RequestHelper } from "../../Lib/Helper/RequestHelper";
import Swal from 'sweetalert2/dist/sweetalert2.js'

@ModuleName("PasswordValidation")
export class PasswordValidation implements AxInit {
    constructor(private _I18nHelper = new I18nHelper(),
        private _requestHelper = new RequestHelper()) { }

    AxInit(): void {
        new AxInput('#password').init();

        //LoginForm
        new AxFormValidation({
            selector: '#formReset',
            rules: {
                password: {
                    required: true,
                    pwcheck: true,
                    minlength: 8,
                },
                PasswordConfirm: {
                    required: true,
                    equalTo: "#password"
                },
            },
            callback: () => {
                this.resetPw();
            }
        }).init();
    }
    
    resetPw() {
        let baseForm = this._requestHelper.objectifyForm($('#formReset').serializeArray());

        return AxessViewer.loadPartialView('/Account/LoginReset', baseForm, (resp) => {
            if (resp.success == true) {
                Swal.fire({
                    title: this._I18nHelper.GetTranslation(Translations.Success),
                    text: resp['message'],
                    icon: 'success',
                    confirmButtonText: 'Ok'
                }).then((result) => {
                    window.location.replace('/Home');
                });
            } else {
                Swal.fire({
                    title: this._I18nHelper.GetTranslation(Translations.Error),
                    text: resp['message'],
                    icon: 'error',
                    confirmButtonText: 'OK'
                })
            }
        }, { silent: true });
    }
}
